import {create} from "zustand";
import {devtools} from "zustand/middleware";

type SessionStore = {
  sessionRemainingSeconds: number | null;
  setSessionRemainingSeconds: (seconds: number) => void;
  decrementSessionRemainingSeconds: () => void;
};

const useSessionStore = create<SessionStore>()(
  devtools((set) => ({
    sessionRemainingSeconds: null,
    setSessionRemainingSeconds: (seconds) =>
      set({sessionRemainingSeconds: seconds}),
    decrementSessionRemainingSeconds: () =>
      set((state) => ({
        sessionRemainingSeconds: Math.max(
          0,
          state.sessionRemainingSeconds ? state.sessionRemainingSeconds - 1 : 0,
        ),
      })),
  })),
);

export {useSessionStore};
